import { bsl } from '@academica-box/utils/scripts/directives/bsl'
import type { Plugin } from 'nuxt/app'

export default defineNuxtPlugin(bsl as Plugin)
